import { render, staticRenderFns } from "./Nalozi.vue?vue&type=template&id=5d813ecd&"
import script from "./Nalozi.vue?vue&type=script&lang=js&"
export * from "./Nalozi.vue?vue&type=script&lang=js&"
import style0 from "./Nalozi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports